import { CasEntityRHFSelect,CasEntitySelectProps} from 'src/compass/shared/components';

export default function RHFUserSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect("User/Select", props);
}
